module.exports = __webpack_public_path__ + "img/ic_favorite_curve_liked.d65ef666.svg";